// /src/pages/Blog.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import blogData from '../data/blogData';
import { Card } from 'react-bootstrap';

export default function Blog() {
  return (
    <div
      className="py-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        filter: 'brightness(0.9) contrast(1.1) saturate(1.2)' // added filter for enhancement
      }}
    >
      <div className="container bg-dark bg-opacity-75 p-4 rounded">
        <h2 className="text-center mb-4">Our Blog</h2>
        <div className="row">
          {blogData.map((article) => (
            <div className="col-md-4 mb-3" key={article.id}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>{article.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">By {article.author}</Card.Subtitle>
                  <Card.Text>{article.content.slice(0, 100)}...</Card.Text>
                  <Link to={`/blog/${article.id}`} className="btn btn-primary">Read More</Link>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
